export interface Movie {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: string;
  rating: number;
  description: string;
  imageUrl: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  featured: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '最新电影', slug: 'latest' },
  { name: '动作电影', slug: 'action' },
  { name: '喜剧电影', slug: 'comedy' },
  { name: '科幻电影', slug: 'scifi' },
  { name: '爱情电影', slug: 'romance' },
  { name: '恐怖电影', slug: 'horror' },
  { name: '经典电影', slug: 'classic' },
  { name: '动画电影', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: '科幻电影',
    categorySlug: 'scifi',
    year: '2026',
    rating: 8.5,
    description: '太阳急速老化，持续膨胀，将在百年内吞噬整个太阳系。面对绝境，人类在地球表面建造出巨大的推进器，带着地球踏上长达2500年的流浪之旅。在这场跨越时空的冒险中，人类将面临前所未有的挑战与抉择，文明存续的希望寄托在每一个勇敢者的肩上。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20Earth%20and%20massive%20space%20thrusters%20in%20dark%20space%2C%20cinematic%20lighting%20with%20blue%20and%20orange%20tones%2C%20epic%20scale%2C%20dramatic%20composition%2C%20professional%20movie%20poster%20design%20style&width=600&height=900&seq=movie-scifi-01&orientation=portrait',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    duration: '173分钟',
    region: '中国大陆',
    featured: true,
  },
  {
    id: 'movie-2',
    title: '满江红',
    category: '最新电影',
    categorySlug: 'latest',
    year: '2026',
    rating: 8.2,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领机缘巧合被裹挟进巨大阴谋之中。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20set%20in%20ancient%20China%20Song%20Dynasty%2C%20dark%20red%20and%20gold%20tones%2C%20mysterious%20atmosphere%2C%20palace%20corridors%2C%20traditional%20Chinese%20costumes%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-latest-01&orientation=portrait',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    duration: '159分钟',
    region: '中国大陆',
    featured: true,
  },
  {
    id: 'movie-3',
    title: '战狼3：使命召唤',
    category: '动作电影',
    categorySlug: 'action',
    year: '2026',
    rating: 8.0,
    description: '冷锋再次接到紧急任务，前往战乱地区营救被困的中国公民。在枪林弹雨中，他展现出中国军人的无畏精神与铁血担当。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20military%20movie%20poster%20with%20soldier%20in%20combat%20gear%2C%20explosive%20background%20with%20fire%20and%20smoke%2C%20intense%20orange%20and%20dark%20tones%2C%20professional%20movie%20poster%20style&width=600&height=900&seq=movie-action-01&orientation=portrait',
    director: '吴京',
    actors: ['吴京', '余男', '赵文卓'],
    duration: '135分钟',
    region: '中国大陆',
    featured: true,
  },
  {
    id: 'movie-4',
    title: '疯狂的石头2',
    category: '喜剧电影',
    categorySlug: 'comedy',
    year: '2026',
    rating: 7.9,
    description: '一块价值连城的翡翠再次成为各方势力争夺的焦点，各路人物阴差阳错地卷入一场啼笑皆非的夺宝闹剧之中。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20multiple%20funny%20characters%20in%20chaotic%20urban%20setting%2C%20bright%20warm%20colors%2C%20playful%20vibe%2C%20professional%20movie%20poster%20design&width=600&height=900&seq=movie-comedy-01&orientation=portrait',
    director: '宁浩',
    actors: ['黄渤', '徐峥', '郭涛'],
    duration: '128分钟',
    region: '中国大陆',
    featured: false,
  },
  {
    id: 'movie-5',
    title: '封神第二部',
    category: '动作电影',
    categorySlug: 'action',
    year: '2026',
    rating: 8.3,
    description: '殷寿暴虐无道，天怒人怨。姜子牙携封神榜下山，辅佐武王伐纣。仙魔大战一触即发，封神大业拉开序幕。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20with%20ancient%20gods%20and%20warriors%20in%20battle%2C%20golden%20and%20crimson%20tones%2C%20grand%20scale%2C%20mythological%20creatures%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-action-02&orientation=portrait',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    duration: '148分钟',
    region: '中国大陆',
    featured: true,
  },
  {
    id: 'movie-6',
    title: '热辣滚烫2',
    category: '喜剧电影',
    categorySlug: 'comedy',
    year: '2026',
    rating: 7.5,
    description: '乐莹在新的生活中继续追寻自我，面对事业与爱情的双重挑战，她用热辣的态度滚烫地活着，笑对人生。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20confident%20female%20lead%2C%20warm%20and%20vibrant%20color%20palette%2C%20urban%20cityscape%20background%2C%20uplifting%20mood%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-comedy-02&orientation=portrait',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    duration: '132分钟',
    region: '中国大陆',
    featured: false,
  },
  {
    id: 'movie-7',
    title: '星际穿越',
    category: '经典电影',
    categorySlug: 'classic',
    year: '2014',
    rating: 9.3,
    description: '在不远的未来，地球气候剧烈变化，粮食作物濒临灭绝。前NASA宇航员库珀被选中参与一项穿越虫洞的星际旅行，为人类寻找新的家园。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%20with%20astronaut%20in%20deep%20space%2C%20wormhole%20visual%2C%20dark%20cosmic%20background%20with%20stars%2C%20cinematic%20lighting%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-classic-01&orientation=portrait',
    director: '克里斯托弗·诺兰',
    actors: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
    duration: '169分钟',
    region: '美国',
    featured: false,
  },
  {
    id: 'movie-8',
    title: '肖申克的救赎',
    category: '经典电影',
    categorySlug: 'classic',
    year: '1994',
    rating: 9.7,
    description: '银行家安迪因被误判谋杀妻子及其情人而入狱，在肖申克监狱中，他凭借才智与毅力，用二十年时间完成了不可思议的救赎。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shawshank%20Redemption%20inspired%20movie%20poster%20with%20man%20in%20rain%20arms%20outstretched%2C%20dark%20dramatic%20lighting%2C%20stormy%20night%20sky%2C%20freedom%20theme%2C%20professional%20poster&width=600&height=900&seq=movie-classic-02&orientation=portrait',
    director: '弗兰克·德拉邦特',
    actors: ['蒂姆·罗宾斯', '摩根·弗里曼'],
    duration: '142分钟',
    region: '美国',
    featured: false,
  },
  {
    id: 'movie-9',
    title: '千与千寻',
    category: '动画电影',
    categorySlug: 'animation',
    year: '2001',
    rating: 9.4,
    description: '少女千寻随父母搬家途中，误入一个神秘的世界。为了拯救变成猪的父母，她在汤婆婆的浴场中工作，经历了一段奇幻的成长之旅。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20inspired%20animated%20movie%20poster%20with%20young%20girl%20in%20magical%20spirit%20world%2C%20Japanese%20bathhouse%2C%20soft%20dreamy%20colors%2C%20whimsical%20atmosphere%2C%20beautiful%20illustration%20style&width=600&height=900&seq=movie-animation-01&orientation=portrait',
    director: '宫崎骏',
    actors: ['柊瑠美', '入野自由', '夏木真理'],
    duration: '125分钟',
    region: '日本',
    featured: true,
  },
  {
    id: 'movie-10',
    title: '泰坦尼克号',
    category: '爱情电影',
    categorySlug: 'romance',
    year: '1997',
    rating: 9.4,
    description: '1912年，泰坦尼克号首航。穷画家杰克与贵族少女罗丝在船上相遇相爱，然而巨轮撞上冰山沉没，他们的爱情面临生死考验。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Titanic%20inspired%20romantic%20movie%20poster%20with%20couple%20on%20ship%20bow%2C%20sunset%20ocean%20background%2C%20warm%20golden%20lighting%2C%20classic%20romantic%20atmosphere%2C%20professional%20poster&width=600&height=900&seq=movie-romance-01&orientation=portrait',
    director: '詹姆斯·卡梅隆',
    actors: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特'],
    duration: '194分钟',
    region: '美国',
    featured: true,
  },
  {
    id: 'movie-11',
    title: '电锯惊魂11',
    category: '恐怖电影',
    categorySlug: 'horror',
    year: '2026',
    rating: 7.2,
    description: '新的拼图杀手出现，一系列精心设计的死亡游戏再次上演。警探必须与时间赛跑，揭开杀手背后的真相。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20dark%20mysterious%20figure%20in%20shadows%2C%20eerie%20green%20and%20black%20tones%2C%20creepy%20atmosphere%2C%20abandoned%20warehouse%20setting%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-horror-01&orientation=portrait',
    director: '凯文·格劳特',
    actors: ['托宾·贝尔', '肖妮·史密斯'],
    duration: '118分钟',
    region: '美国',
    featured: false,
  },
  {
    id: 'movie-12',
    title: '地球脉动3',
    category: '纪录片',
    categorySlug: 'documentary',
    year: '2025',
    rating: 9.8,
    description: '采用最先进的拍摄技术，跨越全球七大洲，深入探索地球上最壮丽的自然奇观与最不可思议的野生动物生存故事。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20style%20with%20diverse%20wildlife%20and%20landscapes%20from%20around%20the%20world%2C%20vibrant%20natural%20colors%2C%20aerial%20shots%2C%20professional%20documentary%20poster&width=600&height=900&seq=movie-doc-01&orientation=portrait',
    director: 'BBC自然历史部',
    actors: ['大卫·爱登堡'],
    duration: '60分钟/集',
    region: '英国',
    featured: false,
  },
  {
    id: 'movie-13',
    title: '唐人街探案4',
    category: '喜剧电影',
    categorySlug: 'comedy',
    year: '2026',
    rating: 7.8,
    description: '唐仁和秦风再次踏上新的侦探之旅，这一次他们来到伦敦，在一桩离奇的密室杀人案中寻找真相。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20detective%20movie%20poster%20with%20two%20male%20leads%20in%20London%20setting%2C%20Big%20Ben%20background%2C%20colorful%20and%20playful%20tone%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-comedy-03&orientation=portrait',
    director: '陈思诚',
    actors: ['王宝强', '刘昊然', '肖央'],
    duration: '140分钟',
    region: '中国大陆',
    featured: true,
  },
  {
    id: 'movie-14',
    title: '阿凡达3：火与灰',
    category: '科幻电影',
    categorySlug: 'scifi',
    year: '2026',
    rating: 8.6,
    description: '杰克·萨利一家继续在潘多拉星球探索新的区域，遭遇灰人族部落。火与灰的交织中，新的冲突与联盟即将展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Avatar%20inspired%20epic%20sci-fi%20movie%20poster%20with%20blue%20alien%20characters%20in%20lush%20alien%20world%2C%20fire%20and%20ash%20elements%2C%20cinematic%20epic%20scale%2C%20professional%20poster&width=600&height=900&seq=movie-scifi-02&orientation=portrait',
    director: '詹姆斯·卡梅隆',
    actors: ['萨姆·沃辛顿', '佐伊·索尔达娜', '西格妮·韦弗'],
    duration: '190分钟',
    region: '美国',
    featured: true,
  },
  {
    id: 'movie-15',
    title: '你的名字',
    category: '爱情电影',
    categorySlug: 'romance',
    year: '2016',
    rating: 8.8,
    description: '生活在乡下的三叶与东京高中生立花泷，某天醒来发现彼此互换了身体。在交错时空中，一段跨越时空的奇妙爱情故事就此展开。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Your%20Name%20inspired%20anime%20movie%20poster%20with%20two%20characters%20reaching%20toward%20each%20other%2C%20beautiful%20sky%20with%20comet%2C%20soft%20dreamy%20lighting%2C%20romantic%20atmosphere%2C%20illustration%20style&width=600&height=900&seq=movie-romance-02&orientation=portrait',
    director: '新海诚',
    actors: ['神木隆之介', '上白石萌音'],
    duration: '107分钟',
    region: '日本',
    featured: false,
  },
  {
    id: 'movie-16',
    title: '釜山行2：半岛',
    category: '恐怖电影',
    categorySlug: 'horror',
    year: '2024',
    rating: 7.0,
    description: '丧尸病毒爆发四年后，朝鲜半岛已沦为废墟。前士兵正锡接到秘密任务返回半岛，发现幸存者们依然在与丧尸进行着殊死搏斗。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20zombie%20horror%20movie%20poster%20with%20post-apocalyptic%20city%20ruins%2C%20survivors%20fighting%2C%20dark%20and%20tense%20atmosphere%2C%20professional%20movie%20poster&width=600&height=900&seq=movie-horror-02&orientation=portrait',
    director: '延尚昊',
    actors: ['姜栋元', '李贞贤'],
    duration: '115分钟',
    region: '韩国',
    featured: false,
  },
];

export const latestMovies = movies.filter(m => m.categorySlug === 'latest' || m.year === '2026').slice(0, 8);
export const actionMovies = movies.filter(m => m.categorySlug === 'action');
export const comedyMovies = movies.filter(m => m.categorySlug === 'comedy');
export const classicMovies = movies.filter(m => m.categorySlug === 'classic');
export const featuredMovies = movies.filter(m => m.featured);